// note: email
export function validateEmail(email) {
  const regex = /[^\s@]+@[^\s@]+\.[^\s@]+/gi;

  return regex.test(email);
}

// note: pathname
export function validatePathName(...path) {
  return path.includes(window.location.pathname);
}

// note: check GPU
export async function checkGPU({ ref }) {
  try {
    const canvas = ref;
    const gl = canvas?.getContext("experimental-webgl", { stencil: true });
    const glExtensionDebugRendererInfo = gl.getExtension(
      "WEBGL_debug_renderer_info"
    );

    if (glExtensionDebugRendererInfo) {
      const renderer = gl.getParameter(
        glExtensionDebugRendererInfo.UNMASKED_RENDERER_WEBGL
      );

      const isNvidiaDetected = renderer.indexOf("GeForce");
      const isAMDDetected = renderer.indexOf("Radeon");
      return isNvidiaDetected > -1 || isAMDDetected > -1;
    }
    return false;
  } catch (error) {
    return false;
  }
}

// note: expand icon
export function handleExpandIconOfRecipintsOrCreator({
  user,
  recipients,
  company,
  creator,
}) {
  let result = false;
  if (
    recipients?.map((recipient) => recipient?.user?._id)?.includes(user) ||
    recipients?.map((recipient) => recipient?.company)?.includes(company) ||
    (user == creator?.user?._id && company == creator?.company)
  ) {
    result = true;
  }
  return result;
}

// note: expand icon for creator.
export function handleExpandIconOfCreator({ user, creator, company }) {
  let result = false;

  if (user == creator?.user?._id && company == creator?.company) {
    result = true;
  }

  return result;
}

// note: handle view ifc file validate
export function handleViewIFCFile({ review, file, workflow_event, user_id }) {
  if (
    process.env.REACT_APP_IS_VIEW_IFC_COOKIE_BROWSER ===
    "IS_VIEW_IFC_COOKIE_BROWSER"
  ) {
    const query = {
      // note code = D3
      // "?code=D3&is_accept=false&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${true}`,
      // "?code=D3&is_accept=true&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_LR=${true}`,
      // "?code=D3&is_accept=true&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${false}`,

      "?code=D3&is_accept=false&is_complete=false": {
        id: review,
        file_id: file,
        is_VOnly: true,
        user_id,
      },
      "?code=D3&is_accept=true&is_complete=false": {
        id: review,
        file_id: file,
        is_LR: true,
        user_id,
      },
      "?code=D3&is_accept=true&is_complete=true": {
        id: review,
        file_id: file,
        is_VOnly: false,
        user_id,
      },

      // note: code = D3 - MRTJ
      // "?code=D3 - MRTJ&is_accept=false&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${true}`,
      // "?code=D3 - MRTJ&is_accept=true&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_LR=${true}`,
      // "?code=D3 - MRTJ&is_accept=true&is_complete=true": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${false}`,

      "?code=D3 - MRTJ&is_accept=false&is_complete=false": {
        id: review,
        file_id: file,
        is_VOnly: true,
        user_id,
      },

      "?code=D3 - MRTJ&is_accept=true&is_complete=false": {
        id: review,
        file_id: file,
        is_LR: true,
        user_id,
      },

      "?code=D3 - MRTJ&is_accept=true&is_complete=true": {
        id: review,
        file_id: file,
        is_VOnly: false,
        user_id,
      },

      // note: code = D2
      // "?code=D2&is_accept=false&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${true}`,
      // "?code=D2&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN}?id=${review}&file_id=${file}`,
      // "?code=D2&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN}?id=${review}&file_id=${file}&is_VOnly=${false}`,

      "?code=D2&is_accept=false&is_complete=false": {
        id: review,
        file_id: file,
        is_VOnly: true,
        user_id,
      },

      "?code=D2&is_accept=true&is_complete=false": {
        id: review,
        file_id: file,
        user_id,
      },

      "?code=D2&is_accept=true&is_complete=true": {
        id: review,
        file_id: file,
        is_VOnly: false,
        user_id,
      },

      // note: code = D2 - MRTJ
      // "?code=D2 - MRTJ&is_accept=false&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${true}`,
      // "?code=D2 - MRTJ&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN}?id=${review}&file_id=${file}`,
      // "?code=D2 - MRTJ&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN}?id=${review}&file_id=${file}&is_VOnly=${false}`,

      "?code=D2 - MRTJ&is_accept=false&is_complete=false": {
        id: review,
        file_id: file,
        is_VOnly: true,
        user_id,
      },

      "?code=D2 - MRTJ&is_accept=true&is_complete=false": {
        id: review,
        file_id: file,
        user_id,
      },

      "?code=D2 - MRTJ&is_accept=true&is_complete=true": {
        id: review,
        file_id: file,
        is_VOnly: false,
        user_id,
      },

      // note : code = D4
      // "?code=D4&is_accept=false&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${true}`,
      // "?code=D4&is_accept=true&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${false}`,
      // "code=D4&is_accept=true&is_complete=true": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${false}`,

      "?code=D4&is_accept=false&is_complete=false": {
        id: review,
        file_id: file,
        is_VOnly: true,
        user_id,
      },

      "?code=D4&is_accept=true&is_complete=false": {
        id: review,
        file_id: file,
        is_VOnly: false,
        user_id,
      },

      "?code=D4&is_accept=true&is_complete=true": {
        id: review,
        file_id: file,
        is_VOnly: false,
        user_id,
      },

      // note : code = D5
      // "?code=D5&is_accept=false&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${true}`,
      // "?code=D5&is_accept=true&is_complete=false": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${false}`,
      // "?code=D5&is_accept=true&is_complete=true": `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${false}`,

      "?code=D5&is_accept=false&is_complete=false": {
        id: review,
        file_id: file,
        is_VOnly: true,
        user_id,
      },

      "?code=D5&is_accept=true&is_complete=false": {
        id: review,
        file_id: file,
        is_VOnly: false,
        user_id,
      },

      "?code=D5&is_accept=true&is_complete=true": {
        id: review,
        file_id: file,
        is_VOnly: false,
        user_id,
      },

      // note: default
      // default: `${
      //   process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
      // }?id=${review}&file_id=${file}&is_VOnly=${true}`,

      default: { id: review, file_id: file, is_VOnly: true, user_id },
    };

    return (
      query[
        `?code=${workflow_event?.code}&is_accept=${workflow_event?.is_accept}&is_complete=${workflow_event?.is_complete}`
      ] || query["default"]
    );
  }

  // note: query default
  const query = {
    // note code = D3
    "?code=D3&is_accept=false&is_complete=false": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${true}`,
    "?code=D3&is_accept=true&is_complete=false": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_LR=${true}`,
    "?code=D3&is_accept=true&is_complete=true": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${false}`,

    // note: code = D3 - MRTJ
    "?code=D3 - MRTJ&is_accept=false&is_complete=false": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${true}`,
    "?code=D3 - MRTJ&is_accept=true&is_complete=false": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_LR=${true}`,
    "?code=D3 - MRTJ&is_accept=true&is_complete=true": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${false}`,

    // note: code = D2
    "?code=D2&is_accept=false&is_complete=false": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${true}`,
    "?code=D2&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN}?id=${review}&file_id=${file}`,
    "?code=D2&is_accept=true&is_complete=true": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${false}`,

    // note: code = D2 - MRTJ
    "?code=D2 - MRTJ&is_accept=false&is_complete=false": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${true}`,
    "?code=D2 - MRTJ&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN}?id=${review}&file_id=${file}`,
    "?code=D2 - MRTJ&is_accept=true&is_complete=true": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${false}`,

    // note : code = D4
    "?code=D4&is_accept=false&is_complete=false": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${true}`,
    "?code=D4&is_accept=true&is_complete=false": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${false}`,
    "code=D4&is_accept=true&is_complete=true": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${false}`,

    // note : code = D5
    "?code=D5&is_accept=false&is_complete=false": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${true}`,
    "?code=D5&is_accept=true&is_complete=false": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${false}`,
    "?code=D5&is_accept=true&is_complete=true": `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${false}`,

    // note: default
    default: `${
      process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN
    }?id=${review}&file_id=${file}&is_VOnly=${true}`,
  };

  return (
    query[
      `?code=${workflow_event?.code}&is_accept=${workflow_event?.is_accept}&is_complete=${workflow_event?.is_complete}`
    ] || query["default"]
  );
}

// note: handle view pdf file validate
export function handleViewPDFFile({ review, file, workflow_event }) {
  if (
    process.env.REACT_APP_IS_VIEW_COOKIE_BROWSER === "IS_VIEW_COOKIE_BROWSER"
  ) {
    const query = {
      // note code = D3
      // "?code=D3&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
      // "?code=D3&is_accept=true&is_complete=false": `${
      //   process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN
      // }?file_id=${file}&review_id=${review}&is_LR=${true}`,
      // "?code=D3&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

      "?code=D3&is_accept=false&is_complete=false": {
        file_id: file,
        review_id: review,
        mode: "view",
      },
      "?code=D3&is_accept=true&is_complete=false": {
        file_id: file,
        review_id: review,
        is_LR: true,
      },
      "?code=D3&is_accept=true&is_complete=true": {
        file_id: file,
        review_id: review,
        mode: "view_comments",
      },

      // note: code = D3 - MRTJ
      // "?code=D3 - MRTJ&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
      // "?code=D3 - MRTJ&is_accept=true&is_complete=false": `${
      //   process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN
      // }?file_id=${file}&review_id=${review}&is_LR=${true}`,
      // "?code=D3 - MRTJ&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

      "?code=D3 - MRTJ&is_accept=false&is_complete=false": {
        file_id: file,
        review_id: review,
        mode: "view",
      },
      "?code=D3 - MRTJ&is_accept=true&is_complete=false": {
        file_id: file,
        review_id: review,
        is_LR: true,
      },
      "?code=D3 - MRTJ&is_accept=true&is_complete=true": {
        file_id: file,
        review_id: review,
        mode: "view_comments",
      },

      // note: code = D2
      // "?code=D2&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
      // "?code=D2&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}`,
      // "?code=D2&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

      "?code=D2&is_accept=false&is_complete=false": {
        file_id: file,
        review_id: review,
        mode: "view",
      },
      "?code=D2&is_accept=true&is_complete=false": {
        file_id: file,
        review_id: review,
      },
      "?code=D2&is_accept=true&is_complete=true": {
        file_id: file,
        review_id: review,
        mode: "view_comments",
      },

      // note: code = D2 - MRTJ
      // "?code=D2 - MRTJ&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
      // "?code=D2 - MRTJ&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN}?id=${review}&file_id=${file}`,
      // "?code=D2 - MRTJ&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

      "?code=D2 - MRTJ&is_accept=false&is_complete=false": {
        file_id: file,
        review_id: review,
        mode: "view",
      },
      "?code=D2 - MRTJ&is_accept=true&is_complete=false": {
        id: review,
        file_id: file,
      },
      "?code=D2 - MRTJ&is_accept=true&is_complete=true": {
        file_id: file,
        review_id: review,
        mode: "view_comments",
      },

      // note : code = D4
      // "?code=D4&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
      // "?code=D4&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,
      // "?code=D4&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

      "?code=D4&is_accept=false&is_complete=false": {
        file_id: file,
        review_id: review,
        mode: "view",
      },
      "?code=D4&is_accept=true&is_complete=false": {
        file_id: file,
        review_id: review,
        mode: "view_comments",
      },
      "?code=D4&is_accept=true&is_complete=true": {
        file_id: file,
        review_id: review,
        mode: "view_comments",
      },

      // note : code = D5
      // "?code=D5&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
      // "?code=D5&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,
      // "?code=D5&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

      "?code=D5&is_accept=false&is_complete=false": {
        file_id: file,
        review_id: review,
        mode: "view",
      },
      "?code=D5&is_accept=true&is_complete=false": {
        file_id: file,
        review_id: review,
        mode: "view_comments",
      },
      "?code=D5&is_accept=true&is_complete=true": {
        file_id: file,
        review_id: review,
        mode: "view_comments",
      },

      // note: default
      // default: `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
      default: {
        file_id: file,
        review_id: review,
        mode: "view",
      },
    };

    return (
      query[
        `?code=${workflow_event?.code}&is_accept=${workflow_event?.is_accept}&is_complete=${workflow_event?.is_complete}`
      ] || query["default"]
    );
  }

  // note: default query
  const query = {
    // note code = D3
    "?code=D3&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
    "?code=D3&is_accept=true&is_complete=false": `${
      process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN
    }?file_id=${file}&review_id=${review}&is_LR=${true}`,
    "?code=D3&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

    // note: code = D3 - MRTJ
    "?code=D3 - MRTJ&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
    "?code=D3 - MRTJ&is_accept=true&is_complete=false": `${
      process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN
    }?file_id=${file}&review_id=${review}&is_LR=${true}`,
    "?code=D3 - MRTJ&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

    // note: code = D2
    "?code=D2&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
    "?code=D2&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}`,
    "?code=D2&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

    // note: code = D2 - MRTJ
    "?code=D2 - MRTJ&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
    "?code=D2 - MRTJ&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_BIMA3D_VIEWER_DOMAIN}?id=${review}&file_id=${file}`,
    "?code=D2 - MRTJ&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

    // note : code = D4
    "?code=D4&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
    "?code=D4&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,
    "?code=D4&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

    // note : code = D5
    "?code=D5&is_accept=false&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
    "?code=D5&is_accept=true&is_complete=false": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,
    "?code=D5&is_accept=true&is_complete=true": `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view_comments`,

    // note: default
    default: `${process.env.REACT_APP_FE_PDF_VIEWER_DOMAIN}?file_id=${file}&review_id=${review}&mode=view`,
  };

  return (
    query[
      `?code=${workflow_event?.code}&is_accept=${workflow_event?.is_accept}&is_complete=${workflow_event?.is_complete}`
    ] || query["default"]
  );
}

export function handleDocumentCommentsOfWorkflow({
  workflow_event,
  gDWDA,
  document,
  page = 1,
  limit = 10,
}) {
  const query = {
    "?code=D2 - MRTJ": `?page=${page}&limit=${limit}&review=${workflow_event?.reviews[1]}&code=${workflow_event?.code}`, // note: MRTJ reviewer
    "?code=D3 - MRTJ": `?page=${page}&limit=${limit}&review=${workflow_event?.reviews[1]}&document_workflow=${gDWDA?.data?.data?._id}&code=${workflow_event?.code}`,
    "?code=D2": `?page=${page}&limit=${limit}&review=${workflow_event?.reviews[0]}&code=${workflow_event?.code}`, // note: Consultant reviewer
    "?code=D3": `?page=${page}&limit=${limit}&document=${document?._id}&document_workflow=${gDWDA?.data?.data?._id}&code=${workflow_event?.code}`,
    "?code=D4": `?page=${page}&limit=${limit}&document=${document?._id}&document_workflow=${gDWDA?.data?.data?._id}&code=${workflow_event?.code}`,
    "?code=D5": `?page=${page}&limit=${limit}&document=${document?._id}&document_workflow=${gDWDA?.data?.data?._id}&code=${workflow_event?.code}`,
  };

  return query[`?code=${workflow_event?.code}`];
}

export function extractPimsLinkToBeFolderPath(pims_link) {
  return pims_link?.slice(
    0,
    pims_link?.indexOf(pims_link?.indexOf("/") + 1) - 1
  );
}
